import {
  Avatar,
  Box,
  Button,
  Flex,
  Skeleton,
  TableContainer,
  Td,
  Text,
  WrapItem,
  chakra,
  keyframes,
} from "@chakra-ui/react";

const StyledChatContainer = chakra(Box, {
  baseStyle: {
    width: "100%",
    height: "auto",
    padding: "16px 16px 16px 0px",
    margin: "0px auto",
    // mt:'auto'
  },
});

const StyledChatLoaderContainer = chakra(Box, {
  baseStyle: {
    width: "100%",
    display: "flex",
    mx: "auto",
    padding: "0px 16px",
  },
});

const StyledChatTableContainer = chakra(Box, {
  baseStyle: {
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    height: "auto",
  },
});

const StyledAvatar = chakra(Avatar, {
  baseStyle: {
    width: "40px",
    height: "40px",
    marginBottom: "auto",
  },
});

const StyledSkeleton = chakra(Skeleton, {
  baseStyle: {
    height: "16px",
    borderRadius: "500px",
  },
});

const StyledTableData = chakra(Td, {
  baseStyle: {
    verticalAlign: "top",
    width: "25%",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    color: "gray.700",
    fontWeight: 400,
    position: "relative",
  },
});

const StyledTableHeader = chakra(Td, {
  baseStyle: {
    color: "gray.700",
    fontWeight: 700,
    fontsize: "16px",
    textAlign: "center",
  },
});

const CustomTableContainer = chakra(TableContainer, {
  baseStyle: {
    border: "1px solid",
    borderColor: "gray.400",
    borderRadius: "12px 12px 0px 0px",
    borderBottom: 0,
    borderLeft: 0,
    maxWidth: "1164px",
    overflowX: "auto",
    height: "auto",
  },
});

const StyledChatErrorContainer = chakra(Box, {
  baseStyle: {
    border: "1px solid",
    borderRadius: "8px",
    padding: "12px 20px",
    minHeight: "48px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    gap: "12px",
  },
});

const StyledChatHeader = chakra(Box, {
  baseStyle: {
    width: "100%",
    height: "63px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // padding: "0px 32px",
  },
});

const StyledGradientText = chakra(Text, {
  baseStyle: {
    bgGradient: "linear(to-r, primary.200, primary.400)",
    bgClip: "text",
    fontSize: "40px",
    fontWeight: 500,
  },
});

const StyledCard = chakra(WrapItem, {
  baseStyle: {
    bg: "gray.100",
    minW: { base: "100%", lg: "295px" },
    height: "135px",
    padding: "32px",
    borderRadius: "40px",
    cursor: "pointer",
    width: { base: "100%", sm: "295px" },
  },
});

const StyledTextForTable = chakra(Text, {
  baseStyle: {
    position: "absolute",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "auto",
    padding: "32px 16px",
    borderBottom: "1px solid",
  },
});

const StyledTableHeading = chakra(Text, {
  baseStyle: {
    color: "gray.700",
    fontWeight: 700,
    fontSize: "24px",
  },
});

const CenterFlex = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    alignItems: "center",
  },
});

export const ColumnFlex = chakra(Flex, {
  baseStyle: {
    flexDir: "column",
  },
});

export const BetweenFlex = chakra(Flex, {
  baseStyle: {
    justifyContent: "space-between",
  },
});

const CenterFlexGap = chakra(Flex, {
  baseStyle: {
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap",
  },
});

const StartCenterFlex = chakra(Flex, {
  baseStyle: {
    alignItems: "center",
  },
});

const StyledPDFItem = chakra(Flex, {
  baseStyle: {
    _dark: {
      border: "1px solid",
      borderColor: "theme.gray.100",
    },
    minH: "32px",
    px: "6px",
    alignItems: "center",
    gap: "8px",
    bgColor: "theme.brown.100",
    width: "fit-content",
    borderRadius: "4px",
    userSelect: "none",
  },
});

export const StyledWithoutPDFSrcCard = chakra(Flex, {
  baseStyle: {
    flex: 1,
    padding: "16px",
    borderRadius: "16px",
    bg: "theme.brown.100",
    border: "1px solid",
    borderColor: "theme.brown.100",
    flexDirection: "column",
    gap: "12px",
    cursor: "pointer",
    maxW: "500px",
  },
});

export const StyledWithPDFSrcCard = chakra(Flex, {
  baseStyle: {
    flex: 1,
    padding: "6px",
    borderRadius: "6px",
    bg: "theme.brown.100",
    border: "1px solid",
    borderColor: "theme.brown.100",
    gap: "12px",
    cursor: "pointer",
    maxW: "500px",
    // minH: '72px',
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const StyledWithoutPDFMoreSrcCard = chakra(Flex, {
  baseStyle: {
    flex: 1,
    padding: "16px",
    borderRadius: "16px",
    bg: "theme.brown.100",
    border: "1px solid",
    borderColor: "theme.brown.100",
    cursor: "pointer",
  },
});

export const StyledReactionItem = chakra(Flex, {
  baseStyle: {
    stroke: "theme.gray.500",
    _hover: {
      stroke: "theme.text.primaryDark",
      color: "theme.text.primaryDark",
    },
    cursor: "pointer",
    gap: "6px",
    alignItems: "center",
    color: "theme.gray.500",
  },
});

const colorAnimation = keyframes`
  0% { opacity: 0.8; }
  50% { opacity: 1; }
  100% { opacity: 0.8; }
`;

export const StyledAnimatedBtn = chakra(Button, {
  baseStyle: (props) => ({
    p: "8px 16px",
    width: "fit-content",
    bgColor: "white",
    backgroundSize: "200% 200%",
    animation: `${colorAnimation} 3s ease-in-out infinite`,
    height: "auto",
    fontSize: "16px",
    cursor: "default",
    fontWeight: 400,
    borderRadius: "500px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "6px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #E0E0E0",
    position: "absolute",
    left: props.left || "24px",
    bottom: props.bottom || "16px",
    transform: "none",
    zIndex: 10,
  }),
});

export {
  CenterFlex,
  CenterFlexGap,
  CustomTableContainer,
  StartCenterFlex,
  StyledAvatar,
  StyledCard,
  StyledChatContainer,
  StyledChatErrorContainer,
  StyledChatHeader,
  StyledChatLoaderContainer,
  StyledChatTableContainer,
  StyledGradientText,
  StyledPDFItem,
  StyledSkeleton,
  StyledTableData,
  StyledTableHeader,
  StyledTableHeading,
  StyledTextForTable,
};
